import { Component, Inject } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Store } from "@ngxs/store";
import { Reminder, CommonService,  UpdateReminder, CreateReminder, GetReminderForUsername } from 'huddyapi';
import { timer } from "rxjs";


@Component({
  selector: 'edit-reminder-dialog',
  templateUrl: 'edit-reminder-dialog.component.html',
  styleUrls: ["./edit-reminder-dialog.component.scss"]
})
export class EditReminderDialog  {
  

  edited : Reminder;
  frequencies: string[] = ["Never", "Daily", "Weekly", "Monthly"];
  weekDays: string[] = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
  monthDays : string[] = this.getMonthDays();
  days : string[] = this.weekDays;
  times : string[] = this.getTimes();
  patientId : number;

  reminderForm = this.formBuilder.group({
    title: ['', [Validators.required, Validators.maxLength(255)]],
    text:  ['', [Validators.required, Validators.maxLength(2552)]],
    endDate:  ['', [Validators.required]],
    atDays: [],
    frequency: [],
    atTimes : ['', [Validators.required]]
});

  constructor(
    public dialogRef: MatDialogRef<EditReminderDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : UntypedFormBuilder,
    private common : CommonService,
    public store : Store
  )
  {
    console.log('data', data);
    this.setForm(data);
  }

  ngOnInit(): void {
   console.log(this.edited);
  }

   getTimes() : string[] {
    console.log('entering getTimes');
    let ret : string[] = [];
    let ampm : string[] = ['am', 'pm'];
    let hours : string[] =[...(Array(12)).keys()].map(n => (n === 0) ? '12' : ''+n);
    let minutes : string[] =[...(Array(4)).keys()].map(n => (''+(n * 15)).padStart(2, '0'));
    ampm.forEach(function (daypart) {
        hours.forEach(function(hour) {
          minutes.forEach(function (minute) {
            ret.push(hour + ':' + minute + ' ' + daypart);
          });
        });
    });
    console.log('times', ret);
    return ret;
  }

  getMonthDays() : string[] {
    return [...(Array(31)).keys()].map(n => ''+(n+1));
  }

  isFormInValid() {
    // console.log(this.reminderForm.value.frequency, this.reminderForm.value.atDays, this.reminderForm.invalid,
    //   this.reminderForm.controls.title.invalid, this.reminderForm.controls.text.invalid,this.reminderForm.controls.frequency.invalid,this.reminderForm.controls.atDays.invalid,this.reminderForm.controls.atTimes.invalid,this.reminderForm.controls.endDate.invalid);

    return (((this.reminderForm.value.frequency != 'Daily') && (this.reminderForm.value.frequency != 'Never')) && (!this.reminderForm.value.atDays ||
      this.reminderForm.value.atDays.length === 0)) || 
     (this.reminderForm.invalid);
  }

  frequencyChanged($event){
    let value : string = $event.value;
    this.reminderForm.value.atDays = [];
    if (value === 'Daily' || value === 'Never') {
      this.days = [];
    } else if (value === 'Weekly') {
      this.days = [].concat(this.weekDays);
    } else if (value === 'Monthly') {
      this.days = [].concat(this.monthDays);
    }
  }

  onSubmitForm(treatmentForm) {
   this.save();
  }

  close() {
     
      this.dialogRef.close();
  }

  getFrequency() : string {
    return this.reminderForm.value.frequency;
  }

  save() {
      let atDays : string  = null;
      if (this.reminderForm.value.atDays && this.reminderForm.value.atDays.length > 0) {
        atDays = this.reminderForm.value.atDays.join(',');
      }
      let atTimes : string  = null;
      if (this.reminderForm.value.atTimes && this.reminderForm.value.atTimes.length > 0) {
        atTimes = this.reminderForm.value.atTimes.join(',');
      }
      
      let g : Reminder = new Reminder({
         id: (this.edited.id && this.edited.id > -1) ? this.edited.id : null,
         title : this.reminderForm.value.title,
         text :  this.reminderForm.value.text,
         endDate: this.reminderForm.value.endDate,
         frequency: this.reminderForm.value.frequency.toUpperCase(),
         atDays : atDays,
         atTimes : atTimes,
         timezone : this.edited.timezone,
         tag : ''+this.patientId,
         username: this.edited.username
      });
    console.log('Document to save', g);  
    let action = (g.id != null) ? new UpdateReminder(g) : new CreateReminder(g);
    this.store.dispatch(action).subscribe(t => {
          timer(3000).subscribe(t => this.store.dispatch(new GetReminderForUsername(g.username)));
          this.close();
        });
  }

  setForm(data : any) {

    this.edited = new Reminder(data);
    this.patientId = data.patientId;
    let atDays : string[] = [];
    if (data.atDays) {
      atDays = data.atDays.split(',');
    }
    let atTimes : string[] = [];
    if (data.atTimes) {
      atTimes = data.atTimes.split(',');
    }

    this.reminderForm.setValue({
      endDate: data.endDate ?? '',
      atDays: atDays,
      atTimes: atTimes,
      frequency: data.frequency ?? [],
      text: data.text,
      title : data.title
    });
   
  }



}

